import { render, staticRenderFns } from "./MenuSedeActiva.vue?vue&type=template&id=21e064ce"
import script from "./MenuSedeActiva.vue?vue&type=script&lang=js"
export * from "./MenuSedeActiva.vue?vue&type=script&lang=js"
import style0 from "./MenuSedeActiva.vue?vue&type=style&index=0&id=21e064ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports